// Favourite Button
// ================

import axios from 'axios';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Culture from '../culture';
import Toaster from './Toaster';

const IS_HU = Culture.getBool();

// const DELAY = 200;
// const CLASS_SENDING = 'sending';
// const ACTIONS = ['add', 'remove'];
const DELAY = 200;
const CLASS_SENDING = 'sending';
const ACTIONS = ['add', 'remove'];
const METHODS = ['post', 'delete'];
// const TOOLTIPS = ['Kedvencekhez adom', 'Törlöm a Kedvencekből'];
const addedMessage = IS_HU ? 'hozzáadva a Kedvencekhez.' : 'added to favourites';
const removedMessage = IS_HU ? 'eltávolítva a Kedvencek közül.' : 'removed from favourites';
const TOOLTIPS = IS_HU ? ['Kedvencekhez adom', 'Törlöm a Kedvencekből'] : ['Add to favourites', 'Remove from favourites'];

const SUCCESS_RESPONSES = [
    { text: addedMessage, style: 'success', icon: 'heart' },
    { text: removedMessage, icon: 'broken-heart' },
];

class FavouriteButton {
    static addEventListener(param, addTooltip = false) {
        if (param instanceof Element) {
            param.addEventListener('click', (e) => { FavouriteButton.onClick(e); });
            if (addTooltip) FavouriteButton.addTooltipAndSetState(param, param.checked);
            return;
        }
        const list = (typeof param === 'string') ? document.querySelectorAll(param) : param;
        list.forEach((element) => {
            if (addTooltip) FavouriteButton.addTooltipAndSetState(element, element.checked);
            element.addEventListener('click', (e) => { FavouriteButton.onClick(e); });
        });
    }

    static createElement(id, checked, className = '') {
        const element = document.createElement('input');
        element.type = 'checkbox';
        element.className = `favourite icon ${className}`;
        element.role = 'button';
        element.dataset.shortId = id;
        FavouriteButton.addTooltipAndSetState(element, checked);
        FavouriteButton.addEventListener(element);
        return element;
    }

    static addTooltipAndSetState(element, checked) {
        const tooltip = new Tooltip(element, {
            fallbackPlacements: [],
            title: TOOLTIPS[Number(checked) || 0],
        });
        FavouriteButton.setState(element, checked);
    }

    static async onClick(e) {
        const checkbox = e.currentTarget;
        checkbox.disabled = true;
        checkbox.classList.add(CLASS_SENDING);
        const i = Number(!checkbox.checked);
        dataLayer.push({ event: `favourites-${ACTIONS[i]}` });

        await axios({
            method: METHODS[i],
            url: `/api/user/favourite/${checkbox.dataset.shortId}`,
        }).then((response) => {
            FavouriteButton.setState(checkbox, checkbox.checked);
            const successResponse = SUCCESS_RESPONSES[i];
            Toaster.toast({
                text: `${checkbox.dataset.shortId} ${successResponse.text}`,
                style: successResponse.style,
                icon: successResponse.icon,
                className: Toaster.CLASS_INTERACTIVE,
                destination: '/profil/kedvencek',
            });
        }).catch(() => {
            FavouriteButton.setState(checkbox, !checkbox.checked);
            Toaster.error(IS_HU ? 'Hiba történt. Kérjük próbálja újra, vagy vegye fel velünk a kapcsolatot!' : 'Something went wrong. Please try again or contact us');
        });
    }

    static setState(checkbox, checked) {
        checkbox.classList.remove(CLASS_SENDING);
        checkbox.checked = checked;
        Tooltip.getInstance(checkbox).setContent({ '.tooltip-inner': TOOLTIPS[Number(checked) || 0] });
        checkbox.disabled = false;
    }
}

export default FavouriteButton;
